<template>
  <div class="course-card">
    <div class="course-card-info">
      <h1>{{ courseInfo.name }}</h1>
      <ul>
        <li>
          <span class="grey">Проходят всего</span>
          <span class="black">{{ courseInfo.new_count }}</span>
        </li>
        <li>
          <span class="grey">Прошли</span>
          <span class="black">{{ courseInfo.passed_count }}</span>
        </li>
        <li>
          <span class="grey">В процессе</span>
          <span class="black">{{ courseInfo.in_the_process_count }}</span>
        </li>
        <li>
          <span class="grey">Не прошли курс</span>
          <span class="black">{{ courseInfo.not_passed_count }}</span>
        </li>
      </ul>
      <button
        class="course-card-button"
        @click="startStage(stagesList[0])"
        v-if="
          isAuth &&
          userRole === 'user' &&
          coursesList.some((el) => {
            return el.id === courseInfo.id
          })
        "
      >
        Начать обучение
      </button>
      <button
        class="course-card-button"
        @click="openFormModal"
        v-if="
          !isAuth ||
          (userRole === 'user' &&
            !coursesList.some((el) => {
              return el.id === courseInfo.id
            }))
        "
      >
        Оставить заявку
      </button>
    </div>
    <b-modal :active.sync="isFormShow" has-modal-card scroll="keep">
      <CreateForm @submit="submitForm" @close-modal="closeFormModal" :form="newForm" />
    </b-modal>
  </div>
</template>

<script>
import CreateForm from '@/components/modal/CreateForm'
import { toastInfo, toastDanger } from '@/lib/toastCfg'

export default {
  components: {
    CreateForm
  },
  data() {
    return {
      isFormShow: false,
      newForm: this.defaultForm()
    }
  },
  props: {
    courseInfo: {
      default: () => {},
      type: Object
    },
    coursesList: {
      default: () => [],
      type: Array
    },
    stagesList: {
      default: () => [],
      type: Array
    }
  },
  computed: {
    isAuth() {
      return this.$store.state.auth.auth
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    branchInfo() {
      return this.$store.state.branches.branchInfo
    },
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    isButtonShow() {
      return this.coursesList && this.coursesList.some((el) => el.id === this.courseInfo.id)
    }
  },
  methods: {
    defaultForm() {
      return {
        name: '',
        phone: '',
        comment: '',
        region: '',
        course_id: this.courseInfo.id
      }
    },
    openFormModal() {
      this.isFormShow = true
      this.newForm = this.defaultForm()
    },
    closeFormModal() {
      this.isFormShow = false
    },
    submitForm() {
      this.$axios
        .post('submit-application', this.newForm)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.closeFormModal()
        })
        .catch(this.$errorToast)
    },
    async startStage(stage) {
      if (!this.isAuth) {
        return
      }
      if (this.userRole === 'leader' && this.branchInfo.id !== this.profileInfo.branch.id) {
        await this.$axios2
          .get('branches/' + this.profileInfo.branch.id)
          .then((resp) => {
            this.$store.commit('setBranchInfo', { list: resp.data })
          })
          .catch(this.$errorToast)
      }
      if (
        this.userRole === 'admin' ||
        this.userRole === 'methodist' ||
        (this.userRole === 'leader' && this.branchInfo.courses.some((el) => el.id === this.courseInfo.id))
      ) {
        this.$router.push('/course-preview/' + stage.course_id)
        return
      }
      if (!this.isButtonShow) {
        this.$buefy.toast.open(toastDanger('Вы не назначены на курс'))
        return
      }
      // const user_course_data = this.courseInfo.course.user_course_data.find(
      //    (el) => el.user_id === this.profileInfo.id
      // )
      // if (this.$moment(user_course_data.date_start).isAfter(this.$moment(new Date()))) {
      //    this.$buefy.toast.open(toastDanger('Дождитесь даты начала прохождения курса'))
      //    return
      // }
      // let date_end = this.$moment(user_course_data.date_start)
      //    .add(this.courseInfo.days_limit, 'days')
      //    .format('YYYY-MM-DD')
      // if (this.$moment(date_end).isBefore(this.$moment(new Date()))) {
      //    if (Number(stage.type) !== 1) {
      //       this.$buefy.toast.open(toastDanger('Время прохождения курса истекло'))
      //       return
      //    }
      //    this.$router.push('/my-courses/' + stage.id)
      //    return
      // }
      this.$router.push('/my-courses/' + stage.id + '?courseId=' + this.courseInfo.id)
    }
  }
}
</script>
